var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDescSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "ogbozvk2ca",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5 .082)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "64aiguxm4b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ogbozvk2ca"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F5FAFF",
    xlinkHref: "#ogbozvk2ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 9.17 5.287-4.12a.1.1 0 0 1 .127.003l4.759 4.12a.1.1 0 0 1-.066.175H7.062A.1.1 0 0 1 7 9.17z",
    stroke: "#538FFF",
    strokeWidth: 2,
    fill: "#538FFF",
    opacity: 0.2,
    mask: "url(#64aiguxm4b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7 18.82 5.287-4.12a.1.1 0 0 1 .127.004l4.759 4.12a.1.1 0 0 1-.066.175H7.062A.1.1 0 0 1 7 18.82z",
    stroke: "#538FFF",
    strokeWidth: 2,
    fill: "#538FFF",
    mask: "url(#64aiguxm4b)",
    transform: "matrix(1 0 0 -1 0 33.65)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDescSort);
export default __webpack_public_path__ + "static/media/desc-sort.6bbd0d89.svg";
export { ForwardRef as ReactComponent };